import React from "react";
import styled from "styled-components";
import { device } from "../../../utils/helpers/breakpoints";

export const SideNav = styled.aside`
  height: 100vh;
  background: #edf0f4;
  // position: fixed;
  @media ${device.tablet} {
    display: ${(props) => (props.displaySideNav ? "block" : "none")};
    position: fixed;
    width: 100%;
    z-index: 3;
  }
`;

export const SideNavTop = styled.div`
  display: none;

  @media ${device.tablet} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 5rem;
    background-color: "white";

    img {
      margin-left: 1.875rem;
      width: 6.25rem;
    }

    svg {
      margin-right: 1.25rem;
      cursor: pointer;
    }
  }
`;

export const SideNavCenter = styled.div`
  width: 100%;
  height: 100vh;
  padding: 0 2.5rem 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  & > img {
    width: 6.25rem;
    margin: 2.381rem 0;
  }

  & > button {
    margin-bottom: 1.875rem;
    width: 100%;
    justify-content: center;
  }

  @media ${device.tablet} {
    padding: 4.375rem 3.75rem 0.5rem;
    & > img {
      display: none;
    }

    & > button {
      display: none;
    }
  }

  @media ${device.mobile} {
    padding: 4.375rem 2.5rem 0.5rem;
  }
`;

export const SideNavBottom = styled.div`
  margin-top: auto;
  width: 100%;
  padding: 0 1.563rem;

  ul {
    display: flex;
    gap: 1.5rem;
    padding: 0;
    margin: 0;

    li {
      list-style-type: none;
      padding-right: 0.313rem;
      font-size: h5;
      font-weight: 500;
      line-height: 1.25rem;
      cursor: pointer;
      color: #797e89;
    }

    li:active {
      orange;
    }
  }

  p {
    font-size: h5;
    font-weight: 500;
    line-height: 1.25rem;
    padding-top: 0.25rem;
    margin: 0;
    color: #797e89;

    span {
      cursor: pointer;
    }

    span:active {
      orange;
    }
  }
`;
